import { configureStore } from '@reduxjs/toolkit'
import { composeWithDevTools } from 'redux-devtools-extension';

import axios from 'axios';

import mapsReducer from './features/map.js'
import yetaiReducer from './features/yetai.js'
import searchReducer from './features/search.js'
import splashReducer from './features/splash.js'
import notificationReducer from './features/notification.js';
import myReducer from './features/my.js';
import lineReducer from './features/line.js';
// import filtersReducer from './features/filters/filtersSlice'

const store = configureStore({
  reducer: {
    maps: mapsReducer,
    yetai: yetaiReducer,
    search: searchReducer,
    splash: splashReducer,
    notification: notificationReducer,
    my: myReducer,
    line: lineReducer,
    // filters: filtersReducer
  },
  // 应用 Redux DevTools 组合函数
  // devTools: process.env.NODE_ENV !== 'production', // 只在开发环境中启用 Redux DevTools
  // enhancers: [composeWithDevTools()],
})

export default store